// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"a25223b7","761":"cc012a57","779":"061f8527","787":"427dc506"}[chunkId] + ".chunk.js";
};